import React from 'react';
import CLPrescription from './CLPrescription';
import LoginTab from '../../AuthModal/LoginTab';
import './SavedPrescription.scss';

const SavedPrescription = props => {
  const {
    dataLocale,
    loading,
    loginStatus,
    user,
    username,
    loginError,
    redisCommonData,
    userInputErr,
    oTPSent,
    registerCallsActions,
    commonCallsAction,
    userInputValidate,
    oTPLoginSuccess,
  } = props;
  return (
    <div className="savedPrescTab">
      {!loginStatus && (
        <div className="use-saved-panel contact-lenskart-sign margin-t25">
          <div className="saved-prescription-sign">
            {dataLocale.SIGN_IN_USE_PREVIOUS_PRESCRIPTION}
          </div>
          <LoginTab
            loginFromCL
            commonActions={commonCallsAction}
            dataLocale={dataLocale}
            loading={loading}
            loginError={loginError}
            oTPLoginSuccess={oTPLoginSuccess}
            oTPSent={oTPSent}
            redisCommonData={redisCommonData}
            registerActions={registerCallsActions}
            user={user}
            userInputErr={userInputErr}
            userInputValidate={userInputValidate}
            username={username}
          />
        </div>
      )}
      {loginStatus && <CLPrescription {...props} />}
    </div>
  );
};

export default SavedPrescription;
